<div class="container-fluid dashboard-container">
    <div class="row">
      <!-- Payment Gateways Section -->
      <div class="col-md-3">
        <div  id="pg_gateway" class="card card-height">
          <div class="card-header">
            <h5 class="card-title title-head">Payment Gateways</h5>
          </div>
          <div class="heading d-flex justify-content-between align-items-center">

            <!-- Sort by Mode Name -->
            <div class="d-flex align-items-center" role="button" (click)="toggleSort('name', 'pay')" style="margin-left: -21px;">
              <span class="head">Mode Name</span>
              <span class="ms-1">
                <ng-container *ngIf="sortState['pay']?.field !== 'name'">
                  <i class="fa-solid fa-arrow-up"></i>
                </ng-container>
                <ng-container *ngIf="sortState['pay']?.field === 'name'">
                  <i *ngIf="sortState['pay']?.direction === 'asc'" class="fa-solid fa-arrow-up"></i>
                  <i *ngIf="sortState['pay']?.direction === 'desc'" class="fa-solid fa-arrow-down"></i>
                </ng-container>
              </span>
            </div>

            <!-- Sort by Sites No -->
            <div role="button" (click)="toggleSort('count', 'pay')" style="margin-right: -16px;">
              <span class="head">Sites No.</span>
              <span class="ms-1">
                <ng-container *ngIf="sortState['pay']?.field !== 'count'">
                  <i class="fa-solid fa-arrow-up"></i>
                </ng-container>
                <ng-container *ngIf="sortState['pay']?.field === 'count'">
                  <i *ngIf="sortState['pay']?.direction === 'asc'" class="fa-solid fa-arrow-up"></i>
                  <i *ngIf="sortState['pay']?.direction === 'desc'" class="fa-solid fa-arrow-down"></i>
                </ng-container>
              </span>
            </div>

          </div>
<div class="card-body card-p" style="overflow-y: scroll;">
  
  <!-- Shimmer -->
  <ng-container *ngIf="filteredPayList.length === 0">
    <div class="shimmer-container" *ngFor="let i of [1,2,3,4,5]">
      <div class="shimmer-item mb-2">
        <div class="shimmer-img me-2" style="width:30px; height:30px;"></div>
        <div class="shimmer-text" style="width:100px; height:14px;"></div>
        <div class="shimmer-text ms-auto" style="width:30px; height:14px;"></div>
      </div>
    </div>
  </ng-container>

  <!-- Actual Data -->
  <div class="payment-gateway-item d-flex justify-content-between align-items-center"
    *ngFor="let gateway of filteredPayList"
    [ngClass]="{'highlight': payvalue === gateway.name.toLowerCase()}">
    <div (click)="sendDataPay(gateway.tableKey.toLowerCase(), gateway.name.toLowerCase(), filteredPayList)" class="w-100">
      <div class="d-flex align-items-center">
        <img width="30" src="assets/DashboardIcon/{{ gateway.name.toLowerCase() }}.png" alt="{{ gateway.name }}" class="me-2">
        <span class="name-s" role="button">{{gateway.name}}</span>
      </div>
    </div>
    <span class="name-c">{{gateway.count}}</span>
  </div>

</div>
        </div>
      </div>
  
      <!-- Supervisor Details Section -->
      <div class="col-md-5">
        <div id="supervisor" class="card card-height">
          <div class="card-header d-flex justify-content-between align-items-center" >
            <h5 class="card-title title-head">Supervisor Details</h5>
             <!-- Search Toggle Icon -->
              <img role="button"
                [src]="showSearch ? 'assets/DashboardIcon/searchicon.svg' : 'assets/DashboardIcon/searchicon.svg'"
                width="25" height="25" alt="Toggle Search" (click)="toggleSearch()">
          </div>
          <!-- Search Input (Toggled) -->
          <div class="p-2" *ngIf="showSearch">
            <input type="text" class="form-control" placeholder="Search by name..." [(ngModel)]="searchTerm" (input)="filterAndSort('super')" />
          </div>
            <div class="heading d-flex justify-content-between align-items-center">

            <!-- Sort by Name -->
            <div class="d-flex align-items-center" role="button" (click)="toggleSort('name', 'super')" style="margin-left: -21px;">
              <span class="head">Name</span>
              <span class="ms-1">
                <ng-container *ngIf="sortState['super']?.field !== 'name'">
                  <i class="fa-solid fa-arrow-up"></i>
                </ng-container>
                <ng-container *ngIf="sortState['super']?.field === 'name'">
                  <i *ngIf="sortState['super']?.direction === 'asc'" class="fa-solid fa-arrow-up"></i>
                  <i *ngIf="sortState['super']?.direction === 'desc'" class="fa-solid fa-arrow-down"></i>
                </ng-container>
              </span>
            </div>

            <!-- Sort by Count -->
            <div role="button" (click)="toggleSort('count', 'super')" style="margin-right: -16px;">
              <span class="head">Sites Allotted</span>
              <span class="ms-1">
                <ng-container *ngIf="sortState['super']?.field !== 'count'">
                  <i class="fa-solid fa-arrow-up"></i>
                </ng-container>
                <ng-container *ngIf="sortState['super']?.field === 'count'">
                  <i *ngIf="sortState['super']?.direction === 'asc'" class="fa-solid fa-arrow-up"></i>
                  <i *ngIf="sortState['super']?.direction === 'desc'" class="fa-solid fa-arrow-down"></i>
                </ng-container>
              </span>
            </div>

          </div>


<div class="card-body card-p" style="overflow-y: scroll;">

  <!-- Shimmer -->
  <ng-container *ngIf="filteredSupervisorList.length === 0">
    <div class="shimmer-container" *ngFor="let i of [1,2,3,4,5]">
      <div class="shimmer-item mb-2">
        <div class="shimmer-img me-2" style="width:30px; height:30px;"></div>
        <div class="shimmer-text" style="width:140px; height:14px;"></div>
        <div class="shimmer-text ms-auto" style="width:30px; height:14px;"></div>
      </div>
    </div>
  </ng-container>

  <!-- Actual Data -->
  <div class="supervisor-item d-flex justify-content-between align-items-center"
    *ngFor="let supervisor of filteredSupervisorList"
    [ngClass]="{'highlight': selectedSupervisor === supervisor.name}">
    <div class="w-100" (click)="sendDataS(supervisor.name, 'supervisor_name')">
      <div class="d-flex align-items-center">
        <img width="30" src="assets/DashboardIcon/avtar.png" alt="{{ supervisor.name }}" class="avatar me-2">
        <span role="button" class="name-s">{{ supervisor.name }}</span>
      </div>
    </div>
    <span class="name-c">{{ supervisor.count }}</span>
  </div>

</div>
        </div>
      </div>
  
      <!-- Processor Details Section -->
      <div class="col-md-4">
        <div id="processor" class="card">
          <div class="card-header">
            <h5 class="card-title title-head">{{ selectedProcessorLabel }}<img class="dropnav-img" src="assets/DashboardIcon/dropnav.svg" style="cursor:pointer;" (click)="toggleProcessorDropdown()">
            <div #processorDropdown class="dropdown-menu show" *ngIf="showProcessorDropdown" style="position: absolute;top: 72%;left: 0;margin-left: 15px;min-width: 222px;">
              <a
                class="dropdown-item"
                *ngFor="let option of processorDropdownOptions1"
                (click)="onProcessorDropdownSelect(option.value,option.label,option.chartname)"
                href="javascript:void(0);"
              >
                {{ option.label }}
              </a>
            </div>
            </h5>
          </div>
          <div class="card-body card-p">
            <div class="chart-container" >
              <div class="revenuegrowth-chart" id="revenuegrowth" >
                <apx-chart
                #chart
                    [series]="revenugrowth.series"
                    [chart]="revenugrowth.chart"
                    [labels]="revenugrowth.labels"
                    [responsive]="revenugrowth.responsive"
                    [colors]="revenugrowth.colors"
                    [dataLabels]="revenugrowth.dataLabels"
                    [tooltip]="revenugrowth.tooltip"
                    [legend]="revenugrowth.legend"
                    
                    
                  ></apx-chart>
                  <!-- <apx-chart [series]="revenugrowth.series" [chart]="revenugrowth.chart" [stroke]="revenugrowth.stroke" [markers]="revenugrowth.markers"
                  [plotOptions]="revenugrowth.plotOptions"[dataLabels]="revenugrowth.dataLabels" [colors]="revenugrowth.colors"
                  [legend]="revenugrowth.legend"[fill]="revenugrowth.fill" [grid]="revenugrowth.grid" [yaxis]="revenugrowth.yaxis" 
                  [xaxis]="revenugrowth.xaxis"[responsive]="revenugrowth.responsive"  [tooltip]="revenugrowth.tooltip"></apx-chart> -->
            </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="siteTable" #tableWrapper>
    <app-table
      TableHeader="Total Sites"
      [totalDisplay]="false"
      [displayAddbutton] = "true"
      ExportFileName="Site Data"
      (clearSupervisorHighlight)="onClearSupervisorHighlight()"
      [statusMap]="statusMapInput"
      [filterConfig]="filterList"
      (statusUpdated)="onStatusUpdated($event)"
  ></app-table>
  </div>  
